import { render } from "./LanguageSwitchComponent.vue?vue&type=template&id=42533dcc"
import script from "./LanguageSwitchComponent.vue?vue&type=script&lang=js"
export * from "./LanguageSwitchComponent.vue?vue&type=script&lang=js"

import "./LanguageSwitchComponent.vue?vue&type=style&index=0&id=42533dcc&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__